module.exports = __webpack_public_path__ + "static/media/mockPhoto.f5c332f9.jpg";